<nb-card>

        <nb-card-header>
          
            <div style="display:flex; width:100%">
                <span>Налаштування</span>   
                 <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="closeModal()">
			<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
		</span>  
             </div>
        </nb-card-header>

 <nb-card-body style="max-width:320px;" class="settingsModalBody">
	 
 
    <div class="streams-page"  > 
    
        	<div>

			<div *ngIf="!chatMode" class="item"> 
		 
				  <div class="cbWrapper"><div> <nb-checkbox  [(checked)]="showTransformed"></nb-checkbox></div></div>
				<div class="itemDescription">Дзеркальне відображення відео</div> 

			</div>
		 
			<div   *ngIf="stream.type === 'live' && !chatMode" class="item"> 
		 
				  <div class="cbWrapper"><div> <nb-checkbox  [(checked)]="disableSeekLine"></nb-checkbox></div></div>
				<div class="itemDescription">Заборонити перемотування назад під час трансляції</div> 

			</div>
		 
		  
			<div  *ngIf="stream.type === 'live' && !chatMode && stream.streamType !== 2" class="item"> 
		 
				  <div class="cbWrapper"><div> <nb-checkbox  [(checked)]="deleteOnComplete"></nb-checkbox></div></div>
				<div class="itemDescription">Видалити запис після завершення трансляції</div> 

			</div>
		 
			<div *ngIf="chatMode" class="item"> 
		 
				  <div class="cbWrapper"><div> <nb-checkbox  [(checked)]="chatNonameEnabled"></nb-checkbox></div></div>
				<div class="itemDescription">Чат без авторизації</div> 

			</div>

		
			<div   *ngIf="stream.type === 'live' && !chatMode" class="item"> 
		 
				  <div class="cbWrapper"><div> <nb-checkbox  [(checked)]="viewersInWatch"></nb-checkbox></div></div>
				<div class="itemDescription">Відображати глядачів онлайн</div> 

			</div>
 
 
		</div>

    
   </div>
  
     

</nb-card-body> 

     <nb-card-footer>

		  <div style="display: flex;">
		    <div style="display: flex; margin-left: auto;">
		 
			   <button nbButton [disabled]="buttonsDisabled"  status="success" (click)="save()">Зберегти </button>
			   <button nbButton [disabled]="buttonsDisabled"  style="margin-left: 10px;" (click)="closeModal()">Скасувати </button>
		    </div>
		</div>
	</nb-card-footer>

</nb-card>
  

	

 
